import type { Mark } from '../document-types';
import type { MarkHandler } from './types';

export class CodeMark implements MarkHandler {
  readonly type = 'code';

  apply(text: string, _mark: Mark): string {
    return `\`${text}\``;
  }
}
